import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";

import { Modal, Button, Input } from "rsuite";
import apiClient from "../../libraries/ApiClient";
import { useContext } from "react";
import { ModelContext } from "../../contexts/ModelContext";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function Patient_CheckReferral_XmarkRegular({
  rowId,
  code,
  time,
  caseCode,
  hospital,
}) {
  const queryClint = useQueryClient();
  const [token, setToken] = useState("");
  const [reason, setReason] = useState("");
  const [Case, setCase] = useState("");
  const {
    setOpenAskSaveModel,
    changeData,
    openSecondModel,
    setOpenSecondModel,
    openSecondModelName,
    setOpenSecondModelName,
  } = useContext(ModelContext);

  const handleOpen = () => {
    console.log(changeData);
    setOpenSecondModelName("Patient_CheckReferral_XmarkRegular");
    setCase(code);
    if (changeData) {
      setOpenAskSaveModel(true);
    } else {
      setOpenSecondModel(true);
    }
  };

  const open = () => {
    return (
      openSecondModel &&
      openSecondModelName === "Patient_CheckReferral_XmarkRegular" &&
      Case == code
    );
  };
  const handleClose = () => setOpenSecondModel(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);

  const sendCheckData = async ({ rowId, code, token, reason }) => {
    const data = {
      Data: {
        RowId: rowId,
        Code: code,
        Value: 0,
        Content: reason,
      },
    };

    const res = await apiClient.postAes(
      "api/referral/SetPatientStatus/Security",
      data
    );

    return res;
  };

  const {
    data: checkData,
    mutate,
    isLoading,
  } = useMutation(sendCheckData, {
    onSuccess() {
      alert("更新成功");
      //queryClint.invalidateQueries("getListData");
      window.location.reload(true);
    },
  });
  //console.log(checkData);
  return (
    <>
      <span style={{ padding: "5px" }} onClick={handleOpen}>
        <Container
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="2.5"
            stroke="#057AFF"
          />
          <path
            d="M15.7632 9.36623C16.0756 9.05388 16.0756 8.54662 15.7632 8.23427C15.4509 7.92191 14.9436 7.92191 14.6313 8.23427L12 10.868L9.36623 8.23676C9.05388 7.92441 8.54662 7.92441 8.23427 8.23676C7.92191 8.54912 7.92191 9.05638 8.23427 9.36873L10.868 12L8.23676 14.6338C7.92441 14.9461 7.92441 15.4534 8.23676 15.7657C8.54912 16.0781 9.05638 16.0781 9.36873 15.7657L12 13.132L14.6338 15.7632C14.9461 16.0756 15.4534 16.0756 15.7657 15.7632C16.0781 15.4509 16.0781 14.9436 15.7657 14.6313L13.132 12L15.7632 9.36623Z"
            fill="#057AFF"
          />
        </Container>
      </span>
      <Modal open={open()} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>確認轉診</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "150px",
            display: "flex",
            flexDirection: "column",
            // height: "100vh",
          }}
        >
          <div style={{ fontSize: "14px", lineHeight: "28px" }}>
            {/* 本院目前可接收「{time}
            {hospital}提報取栓轉診(收案編號{caseCode}
            )」病人進行取栓治療。請跟家屬解釋：到院需再做MRI或CTA評估是否大血管阻塞，才會進行取栓手術。取栓可能的風險有麻醉風險、CKD患者腎功能惡化、心肺疾病者拔管困難等（嚴重者需要氣切）。取栓手術可增加神經功能恢復機會，但不保證病人一定能復原，復原不理想者仍可能癱瘓臥床。若家屬同意，可轉院進行取栓評估，務必請主要決策家屬陪同，並請貴院急診協助以下前置作業：
            <div style={{ padding: "16px" }}>
              <p>1. 完成院際轉診交班</p>
              <p>2. 先換病人服</p>
              <p>3. 左手打20號IC</p>
              <p>4. 放置尿管</p>
            </div> */}
          </div>
          <div
            style={{
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              padding: "8px 0px",
            }}
          >
            經院確認:
            <span style={{ fontSize: "28px", color: "#159895" }}>
              「不轉診」
            </span>
          </div>
          <Input
            placeholder="不轉診原因(建議填寫)"
            as="textarea"
            value={reason}
            onChange={setReason}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              mutate({ rowId, code, token, reason });
            }}
            disabled={isLoading}
            appearance="primary"
          >
            {isLoading ? "資料傳送中" : "確認"}
          </Button>
          <Button onClick={handleClose}>取消返回</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Patient_CheckReferral_XmarkRegular;
